import {
  leadsSequencesListQueryKey,
  sequencesAddLeadsCreateMutation,
  sequencesListListOptions
} from '@crm/api'
import { Properties } from '@crm/types'
import { defaultNonPagination } from '@crm/utils'
import { useInvalidatePredicateQueries } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { showApiErrors } from '@shared/utils'
import { useMutation, useQuery } from '@tanstack/react-query'
import { App, Form, Select } from 'antd'
import { useParams } from 'react-router-dom'

type CampaignCardFormProps = {
  formName: string
  closeModal: () => void
}

export const CampaignCardForm = ({
  closeModal,
  formName
}: CampaignCardFormProps) => {
  const { t } = useLocales()
  const { id: lead } = useParams()
  const [form] = Form.useForm()

  const { invalidateQueries } = useInvalidatePredicateQueries()
  const { notification } = App.useApp()

  const { data, isLoading } = useQuery(
    sequencesListListOptions({ query: { ...defaultNonPagination } })
  )

  const { mutate } = useMutation({
    ...sequencesAddLeadsCreateMutation(),
    onError: (error) => showApiErrors(error, form),
    onSuccess: (e: Properties) => {
      notification.success({
        message: t('success.success'),
        description: e.message
      })

      invalidateQueries([
        leadsSequencesListQueryKey({ path: { lead_id: String(lead) } })
      ])
      closeModal()
    }
  })

  const onSubmit = () => {
    if (!lead) return
    const values = form.getFieldsValue()

    mutate({ path: { id: values.id }, body: { ...values, leads: [lead] } })
  }

  return (
    <Form name={formName} form={form} onFinish={onSubmit} layout="vertical">
      <Form.Item name="id" label={t('campaigns.campaign')}>
        <Select
          loading={isLoading}
          placeholder={t('main.select')}
          options={data?.results?.map((item) => ({
            label: item.label,
            value: item.key
          }))}
        />
      </Form.Item>
    </Form>
  )
}
